import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/partners',
            name: 'partners',
            component: () => import('./views/Home.vue')
        },
        {
            path: '/',
            name: 'scan',
            component: () => import('./views/Scan.vue')
        },
        {
            path: '/register',
            name: 'register',
            component: () => import('./views/Register.vue')
        },
        {
            path: '/details',
            name: 'details',
            component: () => import('./views/Details.vue')
        },
        // {
        //     path: '*',
        //     redirect: './'
        // },
    ],
})
